import { useContext } from 'react';
import { ThemeContext } from 'styled-components';

type Theme = {
  name: string;
  primaryDarkerColor: string;
  primaryLighterColor: string;
  button: {
    textColor: string | null;
  };
  darkGray: string;
  highlightColor: string;
  lightGray: string;
  graphLighterColor: string;
};

export const useTheme = () => {
  const theme = useContext(ThemeContext) as Theme;

  return theme;
};
